<div tuiDropdownOpen [tuiDropdown]="content">
  <button tuiIconButton type="button" iconStart="@tui.bug" size="s"></button>
</div>

<ng-template #content>
  <div class="content">
    <div class="content__info">
      мессенджер:
      <app-internal-messenger-connection-state></app-internal-messenger-connection-state>
    </div>

    <div *ngIf="connectionId" class="content__info">
      connectionId:
      <app-link
        [displayText]="connectionId"
        [pseudo]="true"
        (click)="connectionIdCopyToClipboard(connectionId)"
      ></app-link>
    </div>

    <ng-container *ngIf="deviceId$ | async as deviceId">
      <div class="content__info">
        id устройства:
        <app-link [displayText]="deviceId" [pseudo]="true" (click)="deviceIdCopyToClipboard(deviceId)"></app-link>
      </div>

      <button tuiButton type="button" size="s" (click)="registerDevice(deviceId)">Регистрация устройства</button>
    </ng-container>

    <div class="content__options">
      <app-theme-switcher-mini></app-theme-switcher-mini>
      <app-language-switcher-mini></app-language-switcher-mini>
    </div>
  </div>
</ng-template>
